import React from 'react'
import { confirmAlert } from './ConfirmAlert'
import { TrashIcon } from './Icons'

interface IConfirmDelete {
    title?: string,
    tooltip?: string,
    message: string,
    confirmLabel: string | React.ReactNode,
    cancelLabel?: string,
    onConfirm: () => void,
    onCancel?: () => void,
    overlayClassName?: string,
}

export function confirmDelete(options: IConfirmDelete) {
    const { title, tooltip, message, confirmLabel, cancelLabel, onConfirm, onCancel, overlayClassName } = options
    
    // Create confirmLabel with TrashIcon if it's a string
    const confirmLabelWithIcon = typeof confirmLabel === 'string' ? (
        <>
            <TrashIcon className="" tooltip={tooltip || ''} />
            {confirmLabel}
        </>
    ) : confirmLabel

    confirmAlert({
        title,
        message,
        confirmLabel: confirmLabelWithIcon,
        cancelLabel,
        onConfirm,
        onCancel,
        overlayClassName,
    })
}